export default "__VITE_ASSET__DSI0TCBR__"